import { Icon } from "@/components/atoms";
import { COLOR_CODE } from "@/utils/constants/colors";

const PriceInfo = ({label, value, isHighlighted, icon}) => (
  <div className="col-span-1 pt-4">
    <div className="flex items-center gap-2">
      <span className="key detail-label text-sm">{label}</span>
      {icon && <Icon alt={icon.alt} icon={icon.name} size={icon.size || 'small'} />}
    </div>
    <h2 className="val detail-value text-base font-semibold" style={isHighlighted ? {color: COLOR_CODE._3387DF} : {}}>
      {value !== undefined && value !== null && value !== '' ? value : '-'}
    </h2>
  </div>
)

export default PriceInfo;